import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';

/**
 * Walks the activated-route tree on every NavigationEnd and emits the
 * `data.title` string from the deepest matching child route.
 * Falls back to an empty string when no title is defined.
 */
@Injectable({ providedIn: 'root' })
export class RouterTitleService {
  readonly title$: Observable<string>;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
  ) {
    this.title$ = this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      // Emit immediately so subscribers get a value before the first navigation ends.
      startWith(null),
      map(() => this.deepestTitle(this.activatedRoute)),
    );
  }

  private deepestTitle(route: ActivatedRoute): string {
    let current = route;
    while (current.firstChild) {
      current = current.firstChild;
    }
    return current.snapshot?.data?.['title'] ?? '';
  }
}
